import { Event, EventWrapperProps } from "react-big-calendar";

import { CalendarProps } from "../../../../../components/DiaryCalendar";

export type TaskBadgeProps = React.PropsWithChildren<EventWrapperProps<Event>> &
  Partial<CalendarProps>;

export type TaskBadgeStyleProps = {
  topPercent?: string | number;
  isMonth?: boolean;
  taskType?: string;
};

export enum TaskTypeBadgeEnum {
  GENERAL = "GENERAL",
  UPLIFT = "UPLIFT",
  DELIVERY = "DELIVERY",
  LOCAL = "LOCAL",
  DROP_OFF = "DROP OFF",
  PRE_PACK = "PRE PACK",
  PRE_PACK2 = "PRÉ PACK",
  PACK = "PACK",
  PICKUP = "PICKUP",
  IMPORT = "IMPORT",
  HOME_SURVEY = "HOME SURVEY",
  VIDEO_SURVEY = "VIDEOSURVEY",
  PREFERRED_UPLIFT = "PREFERRED UPLIFT",
  ANY = "",
}
